import { usePersonalityStore, type Personality } from "@/store/personalityStore";
import { cn } from "@/lib/cn";
import { testIds } from "@/testIds";

const OPTIONS: { value: Personality; label: string; hint: string }[] = [
  { value: "pro", label: "Pro", hint: "The green moment and the indicator only" },
  { value: "fun", label: "Fun", hint: "A character, the stamp or the safe when a save matters" },
];

/**
 * Style: Pro | Fun — the segmented switch the save indicator's card carries in
 * its footer and Settings → Appearance mirrors. One store, so the two can
 * never disagree; usePersonalitySync takes it to the server.
 */
export function PersonalityToggle({ className, size = "sm" }: { className?: string; size?: "sm" | "md" }) {
  const personality = usePersonalityStore((s) => s.personality);
  const setPersonality = usePersonalityStore((s) => s.setPersonality);

  return (
    <div
      role="radiogroup"
      aria-label="Style"
      data-testid={testIds.editor.personalityToggle}
      data-value={personality}
      className={cn(
        "inline-flex shrink-0 rounded-[7px] border border-[var(--lilia-border)] bg-[var(--lilia-surface)] p-[2px]",
        className,
      )}
    >
      {OPTIONS.map((o) => {
        const on = personality === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            title={o.hint}
            data-testid={testIds.editor.personalityOption}
            data-value={o.value}
            onClick={() => setPersonality(o.value)}
            className={cn(
              "inline-flex items-center rounded-[5px] px-[11px] text-[12px] text-[var(--lilia-text)] transition-colors",
              size === "md" ? "h-8" : "h-6",
              on
                ? "bg-[var(--lilia-primary-subtle)] font-semibold"
                : "font-normal text-[var(--lilia-text-secondary)] hover:bg-[var(--lilia-hover)]",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--lilia-primary)]",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
